import { render, staticRenderFns } from "./clinics.vue?vue&type=template&id=376b87a0&"
import script from "./clinics.vue?vue&type=script&lang=js&"
export * from "./clinics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports